/* Messages de l'application, à la place des fenêtres natives du navigateur (alert, confirm,
   prompt) : bandeaux en bas d'écran et boîte de dialogue de confirmation ou de saisie. */
export const createFeedbackSlice = (set) => ({
  toasts: [], // [{ id, message, kind: 'error' | 'success' | 'info' }]
  addToast: (toast) =>
    // Un message déjà affiché n'est pas répété (double clic sur Enregistrer, par exemple).
    set((etat) =>
      etat.toasts.some((t) => t.message === toast.message && t.kind === toast.kind)
        ? etat
        : { toasts: [...etat.toasts, toast] },
    ),
  removeToast: (id) => set((etat) => ({ toasts: etat.toasts.filter((t) => t.id !== id) })),
  dialog: null, // { kind: 'confirm' | 'prompt', message, title, labels, danger, defaultValue, resolve }
  setDialog: (dialog) => set({ dialog }),
});
